import moment from 'moment';

import { replaceInPattern } from './string.utils';

import { ReplacementBracesRegime } from 'src/app/shared/models/stringUtils.models';

export const getTimePeaks = (): Record<string, string> => {
  const peaks: Record<string, string> = {};
  const beginOfDay = moment().startOf('date');
  for (let i = 0; i < 48; i++) {
    // TODO implement 12hours format
    const format24 = beginOfDay.format('HH:mm');
    peaks[format24] = format24;
    beginOfDay.add(30, 'minute');
  }
  return peaks;
};

export const dateToApiDate = (date: Date): string => moment(date).format('YYYY-MM-DD');

export const getNextDate = (): string => {
  const nextDate = moment().add(1, 'day');
  while (nextDate.day() === 0 || nextDate.day() === 6) {
    nextDate.add(1, 'day');
  }
  return nextDate.format('YYYY-MM-DD');
};

// Returns default search date string: tomorrow normally, or next Monday if today is Fri/Sat
export const getDefaultSearchDateString = (): string => {
  let increaseDays = 1;
  const dayNumber = moment().day(); // 0=Sun..6=Sat
  if (dayNumber === 5) {
    increaseDays = 3; // Friday -> Monday
  } else if (dayNumber === 6) {
    increaseDays = 2; // Saturday -> Monday
  }
  return dateToApiDate(moment().add(increaseDays, 'days').toDate());
};

export const apiDateFormatToMoment = (format: string): string => {
  const transformers = {
    dd: 'DD',
    d: 'D',
    tt: 'A',
    t: 'A',
    yyyy: 'YYYY',
    yyy: 'YYYY',
    yy: 'YY',
    y: 'YY'
  };
  return replaceInPattern(format, transformers, { braces: ReplacementBracesRegime.noBraces });
};

export const getFormattedTimezoneOffset = (): string => {
  const offset = moment().utcOffset();
  const hours = offset / 60;
  const minutes = offset % 60;
  return `${hours}:${minutes}:00`;
};

const pad = (number: number): string | number => (number <= 99 ? `0${number}`.slice(-2) : number);

export const getTimeHours = (timeFrom: string, timeUntil: string): string[] => {
  const peaks: string[] = [];
  const start = timeFrom.split(':');
  const end = timeUntil.split(':');
  const [startHour, startMinutes] = start;
  const [endHour, endMinutes] = end;
  for (let hour = Number.parseInt(startHour, 10); hour <= Number.parseInt(endHour, 10); hour++) {
    if (hour !== Number.parseInt(startHour, 10) || startMinutes === '00') {
      peaks.push(`${pad(hour)}:00`);
    }
    if (hour !== Number.parseInt(endHour, 10) || endMinutes === '30') {
      peaks.push(`${pad(hour)}:30`);
    }
  }
  return peaks;
};
